import React, { useContext, useMemo } from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";
import AuthContext from "../contexts/AuthContext";
import {
  FaUsers,
  FaFileAlt,
  FaClipboardList,
  FaHistory,
  FaBriefcase,
  FaUser,
  FaRegFileAlt,
  FaQuestionCircle,
} from "react-icons/fa";

const menuConfig = {
  // Perfil ADMIN
  1: [
    { path: "/admin/usuarios", name: "Usuários", icon: <FaUsers /> },
    { path: "/admin/editais", name: "Editais", icon: <FaFileAlt /> },
    { path: "/admin/cargos", name: "Cargos", icon: <FaBriefcase /> },
    { path: "/admin/recursos", name: "Recursos", icon: <FaRegFileAlt /> },
    { path: "/admin/logs", name: "Logs", icon: <FaHistory /> },
  ],
  // Perfil CONTROLADOR
  2: [
    {
      path: "/controlador/editais",
      name: "Gerenciar Editais",
      icon: <FaFileAlt />,
    },
    {
      path: "/controlador/recursos",
      name: "Recursos",
      icon: <FaRegFileAlt />,
    },
    {
      path: "/controlador/cargos",
      name: "Gerenciar Cargos",
      icon: <FaBriefcase />,
    },
    { path: "/meu-perfil", name: "Meu Perfil", icon: <FaUser /> },
  ],
  // Perfil USUARIO
  3: [
    { path: "/editais", name: "Ver Editais", icon: <FaFileAlt /> },
    {
      path: "/minhas-inscricoes",
      name: "Minhas Inscrições",
      icon: <FaClipboardList />,
    },
    { path: "/meus-recursos", name: "Meus Recursos", icon: <FaRegFileAlt /> },
    { path: "/meu-perfil", name: "Meu Perfil", icon: <FaUser /> },
    { path: "/ajuda", name: "Ajuda (FAQ)", icon: <FaQuestionCircle /> },
  ],
};

const MainLayout = () => {
  const { user } = useContext(AuthContext);
  const menuItems = useMemo(() => {
    if (!user) {
      return [];
    }
    return menuConfig[user.perfil_id] || [];
  }, [user]);

  return (
    <div className="main-layout">
      <Sidebar menuItems={menuItems} />
      <main className="main-content" role="main">
        <Outlet />
      </main>
    </div>
  );
};

export default MainLayout;
